import BaseApi from './BaseApi';
import InvoiceModel from 'src/models/leasing/Invoice';

export interface IInvoice {
    getAgreementInvoices(clientNumber: number, projectNumber: number, agreementId: number, jwt: string): Promise<object>;
    createInvoice(clientNumber: number, projectNumber: number, agreementId: number, invoice: InvoiceModel, jwt: string): Promise<object>;
}

export default class Invoice extends BaseApi implements IInvoice {
    constructor(baseURL: string) {
        super(baseURL);
    }

    getAgreementInvoices = (clientNumber: number, projectNumber: number, agreementId: number, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/invoice/by-agreementId/${agreementId}`, jwt);
    };

    createInvoice = (clientNumber: number, projectNumber: number, agreementId: number, invoice: InvoiceModel, jwt: string) => {
        return this.postRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/invoice`, invoice, jwt);
    };
}



// WEBPACK FOOTER //
// ./src/api/Invoice.ts